"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRenderable = exports.create = void 0;
var stateMiddleDelimiter = '-';
var booleanStateDelimiter = '--';
var stateWithParamDelimiter = '---';
function create(namespace, exports, css, depth, id, renderer) {
    var stylesheet = {
        namespace: namespace,
        classes: exports.classes,
        keyframes: exports.keyframes,
        vars: exports.vars,
        stVars: exports.stVars,
        cssStates: cssStates,
        style: style,
        st: style,
        $id: id,
        $depth: depth,
        $css: css,
    };
    if (renderer) {
        renderer.register(stylesheet);
    }
    function cssStates(stateMapping) {
        var classNames = [];
        for (var stateName in stateMapping) {
            var stateValue = stateMapping[stateName];
            var stateClass = createStateClass(stateName, stateValue);
            if (stateClass) {
                classNames.push(stateClass);
            }
        }
        return classNames.join(' ');
    }
    function createBooleanStateClassName(stateName) {
        return "" + namespace + booleanStateDelimiter + stateName;
    }
    function createStateWithParamClassName(stateName, param) {
        return "" + namespace + stateWithParamDelimiter + stateName + stateMiddleDelimiter + param.length + stateMiddleDelimiter + param.replace(/\s/gm, '_');
    }
    function createStateClass(stateName, stateValue) {
        if (stateValue === false ||
            stateValue === undefined ||
            stateValue === null ||
            stateValue !== stateValue // check NaN
        ) {
            return '';
        }
        if (stateValue === true) {
            // boolean state
            return createBooleanStateClassName(stateName);
        }
        var valueAsString = stateValue.toString();
        return createStateWithParamClassName(stateName, valueAsString);
    }
    function style() {
        var classNames = [];
        for (var i = 0; i < arguments.length; i++) {
            // eslint-disable-next-line prefer-rest-params
            var item = arguments[i];
            if (item) {
                if (typeof item === 'string') {
                    classNames[classNames.length] = item;
                }
                else if (i === 1) {
                    for (var stateName in item) {
                        var stateValue = item[stateName];
                        var stateClass = createStateClass(stateName, stateValue);
                        if (stateClass) {
                            classNames[classNames.length] = stateClass;
                        }
                    }
                }
            }
        }
        return classNames.join(' ');
    }
    return stylesheet;
}
exports.create = create;
function createRenderable(css, depth, id) {
    return { $css: css, $depth: depth, $id: id, $theme: true };
}
exports.createRenderable = createRenderable;
//# sourceMappingURL=css-runtime-stylesheet.js.map